import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const ProjectCardSkeleton = (props) => {
  const totaCount = parseInt(props.count) || 1;
  const items = new Array(totaCount).fill(null);
  return (
    <>
      {items.map((_, index) => {
        return (
          <div key={index} className="p-4 rounded-2xl bg-white">
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <div className="text-left">
                <Skeleton count={1} height={150} className="mb-2" />
                <Skeleton count={1} height={60} className="mb-2" />
                <Skeleton count={3} height={20} className="mb-2" />
                <Skeleton count={1} height={46} width={150} className="mb-1" />
                <div className="skeleton-common-grid">
                  <div className="col-span-2">
                    <Skeleton count={1} height={25} />
                  </div>
                  <div>
                    <Skeleton count={1} height={25} />
                  </div>
                </div>
                <div className="skeleton-common-grid">
                  <div className="col-span-2">
                    <Skeleton count={1} height={25} />
                  </div>
                  <div>
                    <Skeleton count={1} height={25} />
                  </div>
                </div>
                <div className="skeleton-common-grid">
                  <div className="col-span-2">
                    <Skeleton count={1} height={25} />
                  </div>
                  <div>
                    <Skeleton count={1} height={25} />
                  </div>
                </div>
              </div>
            </SkeletonTheme>
          </div>
        );
      })}
    </>
  );
};

export default ProjectCardSkeleton;
